import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { toast } from "sonner";

export function InstallPWA() {
  const [deferred, setDeferred] = useState(null);
  const [canPrompt, setCanPrompt] = useState(false);

  const isStandalone =
    window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
  const isIOS = /iphone|ipad|ipod/i.test(window.navigator.userAgent);

  useEffect(() => {
    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferred(e);
      setCanPrompt(true);
    };
    const onInstalled = () => {
      setCanPrompt(false);
      setDeferred(null);
      toast.success("PACEMIA installée sur votre appareil");
    };
    window.addEventListener("beforeinstallprompt", onBeforeInstall);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onBeforeInstall);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (isStandalone) return null;
  if (!canPrompt && !isIOS) return null;

  const install = async () => {
    if (deferred) {
      deferred.prompt();
      await deferred.userChoice;
      setDeferred(null);
      setCanPrompt(false);
    } else if (isIOS) {
      toast.info("Sur iPhone/iPad : touchez le bouton Partager puis « Sur l'écran d'accueil ».", { duration: 7000 });
    }
  };

  return (
    <Button variant="outline" size="sm" className="gap-1 text-xs h-8" onClick={install} data-testid="install-pwa-btn">
      <Download className="h-3.5 w-3.5" /> Installer l'app
    </Button>
  );
}
